import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import * as global from '../../../includes/global';
import { ActivatedRoute } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { CompanyService } from 'src/app/services/Modules/company.service';
@Component({
  selector: 'app-manage-cpts-icds-settings',
  templateUrl: './manage-cpts-icds-settings.component.html',
  styleUrls: ['./manage-cpts-icds-settings.component.css']
})
export class ManageCptsIcdsSettingsComponent implements OnInit {
  tabIndex = 0;
  activatedRouter: string = 'manage-cpt-codes'
  currentUser;
  global = global;
  selectedTabName: any = 'ICDs';
  company_id: any;
  shouldShowCptCalculation: boolean = false;

  constructor(private _authService: AuthService,
    private _route: ActivatedRoute,
    private _companyService: CompanyService

    ) {
    this.company_id = this._route.parent.snapshot.params.id;
    this.currentUser = this._authService.currentUser;
   }

  async ngOnInit() {
    await this.getCompanyPermissions();
  }

  async getCompanyPermissions() {
    const filter = {
      _id: this.company_id
    };
    const project = {
      name: 1,
      permissions: 1,
      company_type: 1
    };
    const populate = {
      permissions: "key value"
    };
    const response: any = await lastValueFrom(this._companyService.getCompany(filter, project, populate));
    if (response.status == 200) {
      this.shouldShowCptCalculation = response.data.permissions.some((permission) => permission.key == 'should_show_note_timelogs_tab');
    }
  }
  onTabChanged($event) {
    this.selectedTabName = $event.tab.textLabel;
  }
}
